import React, { Component, Fragment } from 'react'
import { Table } from 'react-bootstrap'
import Moment from 'moment'
import { faArchive, faClone, faChartBar, faDownload } from '@fortawesome/free-solid-svg-icons'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { getParams, end_point, getMonth } from './helper'

const transactionStatusOptions = [
  { value: 'unverified', label: 'Unverified' },
  { value: 'unpaid', label: 'Unpaid' },
  { value: 'paid', label: 'Paid - Full' },
  { value: 'paidinstal', label: 'Paid - Instal' },
  { value: 'fullrefund', label: 'Full Refund' },
  { value: 'partialrefund', label: 'Partial Refund' },
  { value: 'waitlist', label: 'Waitlist' }
]

// const $ = require('jquery');


class List2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedLink: {},
      labelFields: props.labelFields,
      endpoint: props.endpoint,
      token: getParams().jwt,
      head_coach: props.head_coach,
      organization_id: localStorage.getItem("organization_id"),
      program_endpoint: `${end_point('programs')}/programs`
    };
  }

  componentDidMount(){

    console.log("PROPS", this.props.data)
  }

  cloneProgram(newDocument){
    var document = this.getFields(newDocument);
    console.log('document:', document)
    this.props.cloneProgram(document);
  }

  archiveUser(user){
    if(window.confirm("Archive user?")){
      this.props.archiveUser({archived: true, email: user.email}, user._id);
    }
  }

  getProgramStats = (program) => {
    const enrolledUsers = Array.isArray(program.enrolled_users) ? program.enrolled_users : []
    const enrolled = enrolledUsers.filter((user) => user.status === 'enrolled').length
    const max = program.enrollment_maximum || 0
    const flex = program.enrolment_flex || 0
    return { enrolled, max, flex }
  }

  renderProgramStats = (program) => {
    const { enrolled, max, flex } = this.getProgramStats(program)
    return (
      <span className="rosters-program-actions">
        <span
          className="rosters-program-stats-trigger"
          onClick={(e) => e.stopPropagation()}
          title={`Enrolled: ${enrolled}\nMaximum: ${max}\nFlex: ${flex}`}
        >
          <FontAwesomeIcon icon={faChartBar} className="rosters-program-stats-icon" />
          <span className="rosters-program-stats-tooltip">
            <span className="rosters-program-stats-tooltip-line"><strong>Enrolled:</strong> {enrolled}</span>
            <span className="rosters-program-stats-tooltip-line"><strong>Maximum:</strong> {max}</span>
            <span className="rosters-program-stats-tooltip-line"><strong>Flex:</strong> {flex}</span>
          </span>
        </span>
        {this.props.downloadProgram && (
          <button
            type="button"
            className="rosters-program-download"
            title={`Download roster for ${program.group_name || 'this program'}`}
            aria-label={`Download roster for ${program.group_name || 'this program'}`}
            onClick={(e) => {
              e.stopPropagation()
              this.props.downloadProgram(program)
            }}
          >
            <FontAwesomeIcon icon={faDownload} className="rosters-program-download-icon" />
          </button>
        )}
      </span>
    )
  }

  getTransactionStatus = (transaction) => {
    const status = transaction.payment_gateway && transaction.payment_gateway.status
    if (Array.isArray(status)) {
      return status.length > 0 ? status[status.length - 1].status : ''
    }
    return status && status.status ? status.status : status || ''
  }

  renderTransactionStatus = (transaction, handleClick) => {
    const currentStatus = this.getTransactionStatus(transaction)
    return (
      <select
        className="transactions-inline-status"
        value={currentStatus}
        aria-label="Transaction status"
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation()
          if (this.props.updateTransactionStatus) {
            this.props.updateTransactionStatus(transaction, e.target.value)
          }
        }}
      >
        <option value="" disabled>Select status</option>
        {transactionStatusOptions.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    )
  }

  getFields(newDocument){
    var document = {};
    var matches = newDocument.group_name.match(/\(\d+\)/g);
    matches === null ? document.group_name = `${newDocument.group_name} (1)` :
      document.group_name = newDocument.group_name.slice(0, -3) + `(${parseInt(matches[0].charAt(1))+1})`
    document.additional_notes = newDocument.additional_notes;
    document.ages = newDocument.ages;
    document.archived = newDocument.archived;
    document.assistantCoaches = newDocument.assistantCoaches;
    document.division = newDocument.division;
    document.coach_notes = newDocument.coach_notes;
    document.end_date = newDocument.end_date;
    document.enrollment_maximum = newDocument.enrollment_maximum;
    document.enrolment_flex = newDocument.enrolment_flex;
    document.enrollment_goal = newDocument.enrollment_goal;
    document.expected_costs = newDocument.expected_costs;
    document.head_coach = newDocument.head_coach
    document.organization_id = newDocument.organization_id;
    document.program_description = newDocument.program_description;
    document.registration_end_date = null;
    document.registration_start_date = null;
    document.season = newDocument.season;
    document.sessions = newDocument.sessions
    document.start_date = newDocument.start_date;
    document.type = newDocument.type;
    document.ageVerify = newDocument.ageVerify;
    document.commissioner_1 = newDocument.commissioner_1
    document.udfs = newDocument.udfs ? newDocument.udfs : null
    document.VTsessions = newDocument.VTsessions ? newDocument.VTsessions : null
    return document;
  }

  openModal() {
    this.setState({ showModal: true });
  }

  handleClick(selectedElement, e) {
    console.log('clicked on item', selectedElement)
    if (selectedElement.type === 'secondary') {
      var mainParent = this.props.allData.find(parent => {
        return parent._id === selectedElement.parent_id
      })
      selectedElement = mainParent
    }

    if(e.target.nodeName === "path" && selectedElement.clone === true) {
      window.alert('This program is connected to an External League and cannot be cloned.')
    } else if(e.target.nodeName === "path" && selectedElement.clone !== true){
      if(window.confirm("Clone this program?")){
        this.cloneProgram(selectedElement);
      }
    } else {
      this.setState({ selectedLink: selectedElement })
      this.props.action(selectedElement)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      showModal: false,
      head_coach: nextProps.head_coach
    });
  }

  render() {
    var rthis = this;
    function makeLabel(item, handleClick, handleArchiveUser) {
      var temp = [];
      if (item.programs) {
        var teamNames = ''
        var allAges = ''
        var names = []
        var plans = ``
        var promoCodes = ``
        var account_holder = item.user ? `${item.user.first_name} ${item.user.last_name}` : 'No User Found'
        item.programs.forEach(program => {
          var program_details = item.details.find(league => {return program._id === league._id})
          //console.log("program_details", program_details)
          names.push(<div className="team-names">{program.name}</div>)
          allAges += `${program_details ? `${program_details.ages} | ${program_details.division}` : 'No Info'}\n`
          plans += `${item.plans[program._id] ? item.plans[program._id].plan_name: "No Plan Info"}\n`
          promoCodes += `${item.price_breakdown[program._id] ? item.price_breakdown[program._id].promo_code_key: ''}\n`
          if (program.teams) {
            teamNames = <div className="team-names">{program.teams.toString().split(',').join(', ')}</div>
          }
        })
        rthis.state.labelFields.forEach(fieldPath => {
          var id = Math.floor((Math.random() * 100000) + 1);
          switch (fieldPath.name) {
            case 'program.type':
              return temp.push(makeTD(fieldPath.size, id, handleClick, 'Team', false))
            case 'account_holder':
              return temp.push(makeTD(fieldPath.size, id, handleClick, account_holder, false));
            case 'athlete.first_name':
              return temp.push(makeTD(fieldPath.size, id, handleClick, teamNames, false));
            case 'program.ages':
              return temp.push(makeTD(fieldPath.size, id, handleClick, allAges, true, 'newLine'));
            case 'program.group_name':
              return temp.push(makeTD(fieldPath.size, id, handleClick, names, false))
            case 'plan.plan_name':
              return temp.push(makeTD(fieldPath.size, id, handleClick, plans, false, 'newLine'))
            case 'price_breakdown.promo_code_key':
              return temp.push(makeTD(fieldPath.size, id, handleClick, promoCodes, false, 'newLine'))
            case 'price_breakdown.total':
              return temp.push(makeTD(fieldPath.size, id, handleClick, item.price_breakdown.total, false));
            case 'payment_gateway.status.status':
              return temp.push(makeTD(fieldPath.size, id, handleClick, rthis.renderTransactionStatus(item, handleClick), false, null, 'transactions-inline-status-cell'))
            case 'create_date':
              var time = new Date(item[fieldPath.name])
              var time_a = Moment(`${time.getHours()}:${time.getMinutes()}`, 'hh:mm').format('hh:mm A')
              return temp.push(makeTD(fieldPath.size, id, handleClick, `${getMonth(time.getMonth() + 1)} ${time.getDate()}, ${`${time.getFullYear()}`.slice(2,4)} ${time_a}`, false));
            default:
              return temp.push(makeTD(fieldPath.size, id, handleClick, item[fieldPath.name], false))
          }
        })
      } else {
        rthis.state.labelFields.forEach(function (fieldPath) {
          var id = Math.floor((Math.random() * 100000) + 1);
          if(fieldPath.name === "start_date"){
            temp.push(makeTD(fieldPath.size, id, handleClick, `${getMonth(item[fieldPath.name].slice(5,7))} ${item[fieldPath.name].slice(8,10)}, ${item[fieldPath.name].slice(2,4)}`));
          } else if (fieldPath.name === "program_info") {
            temp.push(makeTD(fieldPath.size, id, handleClick, rthis.renderProgramStats(item), false, null, 'rosters-program-stats-cell'));
          } else if (fieldPath.name ==='program.type') {
            temp.push(makeTD(fieldPath.size, id, handleClick, 'Player'));
          } else if(fieldPath.name === "create_date"){
            var time = new Date(item[fieldPath.name])
            var time_a = Moment(`${time.getHours()}:${time.getMinutes()}`, 'hh:mm').format('hh:mm A')
            temp.push(makeTD(fieldPath.size, id, handleClick, `${getMonth(time.getMonth() + 1)} ${time.getDate()}, ${`${time.getFullYear()}`.slice(2,4)} ${time_a}`, false));
          } else if (fieldPath.name === "head_coach") {
            var coach = JSON.stringify(rthis.props.head_coach) === '{}'? null: rthis.props.head_coach[item[fieldPath.name]]
            temp.push(makeTD(fieldPath.size, id, handleClick, coach));
          } else if (fieldPath.name === "extras.phone") {
            temp.push(makeTD(fieldPath.size, id, handleClick, item.extras.phone));
          } else if (fieldPath.name === "extras.date_of_birth_formatted") {
              temp.push(makeTD(fieldPath.size, id, handleClick, item.extras.date_of_birth_formatted));
          } else if (fieldPath.name === "program.name"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.program.name, false));
          } else if (fieldPath.name === "program.ages"){
            temp.push(makeTD(fieldPath.size, id, handleClick, `${item.program.ages} | ${item.program.division}`))
          } else if (fieldPath.name === "program.group_name"){
            var group_name = item.program.group_name
            if(item.team_name){
              group_name = `${item.program.group_name} [${item.team_name}]` 
            }
            temp.push(makeTD(fieldPath.size, id, handleClick, group_name, false));
          } else if (fieldPath.name === "plan.plan_name"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.plan.plan_name, false));
          } else if (fieldPath.name === "price_breakdown.promo_code_key"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.price_breakdown.promo_code_key, false));
          } else if (fieldPath.name === "price_breakdown.promo_code"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.price_breakdown.promo_code));
          } else if (fieldPath.name === "athlete.first_name"){
            temp.push(makeTD(fieldPath.size, id, handleClick, `${item.athlete.first_name} ${item.athlete.last_name}`));
          } else if (fieldPath.name === "account_holder"){
            temp.push(makeTD(fieldPath.size, id, handleClick, `${item.parent.first_name} ${item.parent.last_name}`));
          } else if (fieldPath.name === "price_breakdown.total"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.price_breakdown.total));
          } else if (fieldPath.name === "payment_gateway.status.status"){
            temp.push(makeTD(fieldPath.size, id, handleClick, rthis.renderTransactionStatus(item, handleClick), false, null, 'transactions-inline-status-cell'));
          } else if (fieldPath.name === "type"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.type));
          } else if (fieldPath.name === "group_name"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.group_name));
          } else if (fieldPath.name === "season"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.season.replace(/-/g, " ")));
          } else if (fieldPath.name === "division"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.division));
          }else if (fieldPath.name === "ages"){
            temp.push(makeTD(fieldPath.size, id, handleClick, item.ages));
          } else if (fieldPath.name === "clone"){
            temp.push(makeTD(fieldPath.size, id, handleClick, <FontAwesomeIcon icon={faClone} size="1x" color={item.clone === true ? 'grey' : 'white'} className={item.clone === true ? 'disabled-clone' : '' }/>));
          } else if (fieldPath.name === "archive"){
            temp.push(makeTD(fieldPath.size, id, handleArchiveUser, <div title="Archive" style={{padding: "5px"}} className={"hint-tip"} ><FontAwesomeIcon icon={faArchive} size="1x"/></div>));
          } else {
            temp.push(makeTD(fieldPath.size, id, handleClick, item[fieldPath.name], false));
          }
        })
      }     
      return temp
    }

    function makeTD(size, key, handleClick, item, capFirstLetter = true, newLine, className = ''){
      if(!(item === undefined || item === null || item === '') ){
        if(item === 'approved' || item === 'paid'){
          item = 'Paid Full'
        } else if (item === 'paidinstal'){
          item = 'Paid Instal'
        } else if (item === 'fullrefund'){
          item = 'Full Refund'
        } else if (item === 'partialrefund'){
          item = 'Partial Refund'
        } else if( item === 'co-ed' && capFirstLetter){
          item = 'Co-Ed'
        } else if(typeof(item) === 'string' && capFirstLetter && !newLine){
          item = item.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
        } else if(newLine) {
          if (capFirstLetter) {
            item = item.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
          }
          return <td key={key} onClick={handleClick} style={{borderTop: "none", width: size}} className={className ? `EF2-tnx ${className}` : 'EF2-tnx'}>{item}</td>
        }
        return <td key={key} onClick={handleClick} style={{borderTop: "none", width: size}} className={className}>{item}</td>
      } else {
        return <td key={key} onClick={handleClick} style={{borderTop: "none", width: size}} className={className}></td>
      }
    }

    return (
      <div className="scrollable-listgroup">
        <Table className="white-text tb-grid">
          <tbody>
            {
              this.props.data.map((item, index) => {
                let handleClick = this.handleClick.bind(this, item)
                let handleArchiveUser = this.archiveUser.bind(this, item);
                  const rowKey = item && (item._id || item.id || item.email || item.name)
                    ? `${item._id || item.id || item.email || item.name}-${index}`
                    : `row-${index}`;
                  return (
                    <tr className="tableHoverable" key={rowKey} style={{ cursor: 'pointer'}}>
                      {makeLabel(item, handleClick, handleArchiveUser)}
                    </tr>
                  )
              }, this)
            }
          </tbody>
        </Table>
      </div>
    )
  }
}
export default List2;
